import axios from "axios";

document.addEventListener("DOMContentLoaded", () => {
    (() => {

        const newsletterWrapper = document.getElementsByClassName("Newsletter");
        const newsletterForm = document.getElementsByClassName("Newsletter__form");
        const newsletterCountrySelect = document.getElementsByClassName("Newsletter__form-col--country");
        const successResponseDiv = document.getElementsByClassName("Newsletter__post-message--success");
        const errorResponseDiv = document.getElementsByClassName("Newsletter__post-message--error");

        init();

        function init() {
            if (newsletterForm.length > 0) {
                resetForm();
                newsletterForm[0].addEventListener("submit", (event) => {
                    event.preventDefault();
                    onFormSubmit(e);
                });
            }
        }

        function resetForm() {
            newsletterWrapper[0].classList.remove("Newsletter--done");
            successResponseDiv[0].innerHTML = "";
            errorResponseDiv[0].innerHTML = "";
        }

        function onFormSubmit() {
            const inputFields = newsletterForm[0].querySelectorAll(".Newsletter__form-col-field");
            const formData = new FormData;
            formData.append("country", newsletterCountrySelect[0].value);
            formData.append("action", "abba_signup");

            const formErrors = [];
            for (let i = 0; i < inputFields.length; i++) {
                switch (inputFields[i].name) {
                    case 'firstName':
                        if (!validateName(inputFields[i].value)) {
                            formErrors.push({
                                element: inputFields[i]
                            });
                        } else {
                            formData.append("firstName", inputFields[i].value);
                        }
                        break;
                    case 'email':
                        if (!validateEmail(inputFields[i].value)) {
                            formErrors.push({
                                element: inputFields[i]
                            });
                        } else {
                            formData.append("email", inputFields[i].value);
                        }
                        break;
                    case 'accept_pp':
                        if (!inputFields[i].checked) {
                            formErrors.push({
                                element: inputFields[i]
                            });
                        }
                        break;
                }
            }

            if (formErrors.length > 0) {
                renderFormErrors(formErrors);
            } else {
                sendForm(formData);
            }
        }

        function renderFormErrors(formErrors) {
            for (let i = 0; i < formErrors.length; i++) {
                formErrors[i].element.classList.add("invalid");
            }
        }

        function validateEmail(val) {
            const regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regEx.test(val)
        }

        function validateName(val) {
            return val.replace(/\s\d/g, '').length > 1 ? true : false;
        }

        async function sendForm(data) {
            try {
                const response = await axios({
                    method: 'post',
                    url: ajax_object.ajax_url,
                    data: data,
                });
                parseResponse(response.data);
            } catch (e) {
                console.log(e);
                this.setError(this.copyManager.getCopy(COPY.GENERAL_ERROR));
            }
        }

        function parseResponse(body) {
            successResponseDiv[0].innerHTML = "";
            errorResponseDiv[0].innerHTML = "";
            if (body.message == "Successfully subscribed") {
                newsletterWrapper[0].classList.add("Newsletter--done");
                successResponseDiv[0].innerHTML = "Thank you!";
            } else {
                errorResponseDiv[0].innerHTML = body.errors.map((e) => { return e.message; }).join(" ");
            }
        }

    })()
});